module.exports = __webpack_public_path__ + "img/broken clouds.c1100a90.jpg";